<template>
  <div class="containerLike">
    <van-tabs v-model="active" animated @change="onActiveChange(active)">
      <!-- :badge="index.num > 0 ? index.num : ''" -->
      <van-tab
        v-for="index in chatStatusList"
        :key="index.id"
        :title="index.title"
      ></van-tab>
    </van-tabs>
    <div class="noOrders" v-if="noList">
      <div v-if="!firstLoading">
        <div>你还没有消息哦...</div>
      </div>
      <van-loading v-else type="spinner" />
    </div>
    <div class="main" v-show="noList == false">
      <div style="height: 100%; overflow: auto">
        <div style="height: calc(100% - 10.2vw); overflow: auto">
          <div>
            <div class="list">
              <div class="everylist">
                <div class="avatar" v-if="list.avatarUrl">
                  <img
                    :src="list.avatarUrl"
                    alt=""
                    style="border-radius: 50%"
                  />
                </div>
                <div class="avatar" v-else>
                  <img
                    src="../../../assets/images/default.jpeg"
                    alt=""
                    style="border-radius: 50%"
                  />
                </div>
                <div style="flex: 1; padding: 0 10px">
                  <div class="flexBetween">
                    <div class="name-list">{{ list.name }}</div>
                    <div class="ClickLike-box">
                      <!-- <van-badge content="5"/> -->
                      <img :src="src" alt="" @click="ClickLike" />
                      <div class="animate" v-show="ClickLike_Status"></div>
                      <span
                        class="likeNum"
                        style="color: #ee0a24; font-size: 2.6vw"
                      >
                        {{ likeNum }}
                      </span>
                    </div>
                  </div>

                  <!-- <div class="flex-row">
                    
                  </div> -->
                  <div class="flex-between" style="margin-top: 13px">
                    <div class="tel">{{ list.phoneNumber }}</div>
                    <div class="timer">{{ list.createTime }}</div>
                  </div>
                </div>
                <!-- <div class="every">
                  
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBackground">
      <div class="userBottom" @click="onSubmit">
        <img src="../../../assets/images/addUser.png" alt="" />
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  PullRefresh,
  NavBar,
  Loading,
  Overlay,
  Badge
} from "vant";
import service from "../../api/like/index";
import loading from "../../components/loading/loading";
export default {
  name: "ClickLike",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    // [Dialog.name]: Dialog,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
    [Badge.name]: Badge,
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay,
    loading
  },
  data() {
    return {
      noList: true,
      isLoading: true, //loading状态
      active: 0,
      chatStatusList: [
        { name: 0, title: "我的点赞" },
        { name: 1, title: "好友的点赞" }
      ],
      MesType: 0,
      chatContent: {},
      list: [],
      //   page: 1,
      //   pageSize: 10,
      reachBottom: false,
      loading: false,
      firstLoading: false,
      ClickLike_Status: false,
      src: "",
      dz_Name: "赞",
      // 点赞前的图片
      src_dz: require("../../../assets/images/love.png"),
      dzd_status: false, // 点赞状态, 如果没有点赞 false  点赞之后就是 true
      // 点赞后的图片
      src_dzd: require("../../../assets/images/love.png"),
      arrList: [],
      likeNum: 500
    };
  },
  watch: {
    // 通过监听 点赞状态 改变 显示的字体
    dzd_status(val) {
      if (val) {
        // this.dz_Name = "取消";
      }
    }
  },
  mounted() {
    this.init();
    this.getLove();
  },
  methods: {
    // 取随机数
    produceDataSeries() {
      //需要产生x个随机数，且x个随机数之和等于500
      let arr = new Array(this.list.length).fill(0);
      for (let i = 0; i < 500; i++) {
        //parseInt接收string，所以需要转一趟
        /**
         * 换成生活中的场景，就是一百个苹果分给十个人，我们可以一个一个的取出，随机分给某个人，直到分完
         * 在js里面，十个人即是一个长度为十的数组，每次数组随机一个位置加一，执行一百次
         */
        var num = parseInt((Math.random() * this.list.length).toString());
        arr[num]++;
      }
      console.log(arr.length);
      this.arrList = arr;
      // return arr;
    },
    onActiveChange(active) {
      //   this.firstLoading = true;
      //   this.loading = true;
      this.isLoading = true;
      if (active == 0) {
        this.noList = false;
        this.getList().then((list) => {
          this.firstLoading = false;
          this.loading = false;
          console.log(list, active, 166);
          this.list = list;
          this.isLoading = false;
          if (list == "" || list == null) {
            this.noList = true;
          } else {
            this.noList = false;
            this.list = list;
          }
          // if (list.length>0) {
          //   this.list = list;
          // } else {
          //   // this.list = {};
          //   this.noList = true;
          // }
        });
      } else {
        this.isLoading = false;
        this.noList = true;
      }
      // this.noList = true;
    },
    init() {
      // debugger
      // this.loading = true;
      // service.get().then((res) => {
      //   if (res.statusCode == 200) {
      //     this.list = res.data;
      //   }
      // });
      this.isLoading = false;
      this.getList().then((list) => {
        this.isLoading = false;
        this.loading = false;
        console.log(list,216)
        if(list == null || list == ""){
          this.noList = true;
        }else{
          this.noList = false;
        list.createTime = list.createTime.slice(0, 16);
        this.list = list;
        }

        this.firstLoading = false;
        
      }).catch(err=>{
        this.isLoading = false;
      });
    },
    // 我的点赞
    getList() {
      return new Promise((resolve, reject) => {
        service
          .get()
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    getLove() {
      this.src = this.src_dz;
    },
    // 点赞
    ClickLike() {
      // 说明已经点赞了, 如果再次点击 就是取消点赞
      // if (this.dzd_status) {
      //   this.dz_Name = "赞";
      //   this.src = this.src_dz;
      //   this.dzd_status = false;
      //   return;
      // }
      this.likeNum++;
      this.ClickLike_Status = true;
      setTimeout(() => {
        this.ClickLike_Status = false;
        this.src = this.src_dzd;
        this.dzd_status = true;
      }, 1000);
    },

    onSubmit() {
      Toast("此功能还未完善");
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.containerLike {
  min-height: 100vh;
  .bottomBackground {
    // bottom: 28px;
    display: flex;
    justify-content: center;
  }
  .userBottom {
    display: flex;
    justify-content: center;
    width: 300px;
    bottom: 28px;
  }
  .main {
    height: calc(100% - 70px);
  }
  .ClickLike-box {
    position: relative;
    img {
      width: 18px;
      height: 16px;
      vertical-align: middle;
      position: absolute;
      right: 10px;
    }
    .animate {
      position: absolute;
      width: 18px;
      height: 16px;
      z-index: 100;
      animation: ClickLikeAni 1s ease-in-out;
      background-image: url("../../../assets/images/love.png");
      background-size: cover;
      opacity: 0.6;
      right: 10px;
    }
  }
  @keyframes ClickLikeAni {
    0% {
      top: 0px;
    }
    10% {
      top: -10px;
    }
    20% {
      top: -20px;
    }
    30% {
      top: -30px;
    }
    40% {
      top: -40px;
      transform: rotate(6deg);
    }
    50% {
      top: -50px;
      transform: rotate(12deg);
    }
    60% {
      top: -60px;
      transform: rotate(6deg);
    }
    70% {
      top: -70px;
      transform: rotate(0deg);
    }
    80% {
      top: -80px;
      transform: rotate(-6deg);
    }
    90% {
      top: -88px;
      transform: rotate(-12deg);
    }
    100% {
      top: -90px;
      transform: rotate(-6deg);
    }
  }

  // :first-child
  .van-tabs {
    border-top: 1px solid #f7f7f7;
    border-bottom: 1px solid #f7f7f7;
  }
  @{deep}.van-tabs--line .van-tabs__wrap {
    height: 9.73333vw;
    padding: 2vw 0;
    background: #fff;
  }
  @{deep}.van-tab:nth-of-type(1) {
    border-right: 1px solid #c1c1c1;
  }
  @{deep}.van-tabs__content--animated {
    height: 100%;
  }
  @{deep}.van-tab__pane,
  @{deep}.van-tab__pane-wrapper {
    height: 100%;
  }

  .list {
    padding: 0 3.7vw;
    background: #fff;
  }
  .likeNum {
    color: rgb(238, 10, 36);
    font-size: 2.6vw;
    position: absolute;
    right: -13px;
  }
  // .flex-row {
  //   font-size: 14px;
  // }
  .look {
    background: linear-gradient(-45deg, #ee0a24, #f96f7f);
    color: #fff;
    height: 31px;
    border-radius: 5px;
    border: 0;
    width: 57px;
    height: 31px;
  }

  .yellow {
    background: linear-gradient(-45deg, #ff7e00, #ffb64e);
    border: 0;
    margin-right: 15px;
    color: #fff;
    height: 31px;
    border-radius: 5px;
    width: 78px;
  }
  .flex_r {
    padding-left: 2vw;
  }
  .tel {
    font-size: 14px;
  }
  .list_no {
    color: #828282;
    margin-left: 2.5vw;
    font-size: 14px;
  }
  .avatar {
    width: 35px;
    height: 35px;
  }
  .refuse {
    color: #676767;
  }
  .success {
    color: #ee0a24;
  }
  .timer {
    color: #9f9f9f;
    font-size: 13px;
  }
  .everylist {
    display: flex;
    border-bottom: 1px solid #e6e6e6;
    margin: 0 0.15rem;
    height: 13.2vw;
    padding: 15px 0;
  }
  .every {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>